import { css } from 'styled-components';

export const borderedOutline = css`
  outline: 2px solid ${({ theme }) => theme.palette.background.secondary};
`;
